import { rem } from 'polished';
import styled from 'styled-components';
import { OrderPanelStyled, PriceCss } from '../OrderPanelStyled';

export const OrderPanelStyledAC = styled(OrderPanelStyled)`
    background: ${({ theme }) => theme.colors.grey6};

    &.isShowPriceExcludedVAT-panel {
        .currencyLabel__suffix--OTR {
            font-size: ${rem('12px')};
        }
    }

    .calculator {
        &:hover {
            .linkIcon {
                svg > path {
                    fill: ${({ theme }) => theme.colors.grey5};
                }
            }
        }
        .txt {
            span {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                font-weight: normal;
                border-bottom: unset;
            }
            &:hover {
                color: ${({ theme }) => theme.colors.red} !important;

                span {
                    border-color: ${({ theme }) => theme.colors.red} !important;
                }
            }
        }
    }

    .wrapper {
        .section {
            border-color: ${({ theme }) => theme.colors.grey26} !important;
            border-width: 1px !important;

            .order-panel-price-container {
                ${PriceCss}

                .calculator {
                    .linkText {
                        border-bottom: unset;
                    }
                }
                .calculator svg {
                    height: ${rem(31)};
                    margin-top: ${rem(5)};
                }

                .content {
                    .header {
                        font-size: ${({ theme }) => theme.fontSizes.h6};
                    }
                    .body {
                        .body-wrapper {
                            .price {
                                font-size: ${({ theme }) => theme.fontSizes.h4};
                                color: ${({ theme }) => theme.colors.grey5};
                            }
                            .or {
                                line-height: 1.5;
                                color: ${({ theme }) => theme.colors.grey5};
                            }
                            .prefix {
                                color: ${({ theme }) => theme.colors.grey5};
                            }
                            .infoIcon {
                                .icon-wrapper {
                                    padding-top: unset;

                                    svg {
                                        circle {
                                            fill: ${({ theme }) => theme.colors.grey5};
                                            stroke: none;
                                        }

                                        line {
                                            stroke: ${({ theme }) => theme.colors.white};
                                            stroke-width: ${rem('3px')};
                                        }
                                    }
                                }
                            }
                        }
                        .footer {
                            font-size: ${({ theme }) => theme.fontSizes.textTiny};
                        }
                    }
                }
            }
        }

        .section-middle {
            .section-middle-wrapper {
                .delivery {
                    color: ${({ theme }) => theme.colors.grey5};
                }
            }
        }

        .section-divider {
            background: ${({ theme }) => theme.colors.grey14};
        }
    }
`;
